<template>
  <main-layout :selectedMenu="'home'">
    <div class="do-competition contantGeek" v-if="language==='zh'">
      <div class="geekBoxs eventintros">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <!--<p>导航栏</p>-->
              <li>
                <router-link :to="{name: 'presentfuture', params: {matchId:matchId}}">
                  <a href>
                    首页
                    <img src="/static/geeknext.png" alt />
                  </a>
                </router-link>
              </li>
              <li class="geekMenuActive">
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">获奖公示</router-link>
              </li>
              <li>
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  入围作品
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:matchId,page:1}}">
                  参赛作品
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:matchId,page:2}}">
                  近期事件
                  <img src="/static/geeknext.png" />
                </router-link>
              </li>
            </ul>
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">报名通道</span>
          <a class="baroads unbaroads" v-show="matchObject.status == 1"></a>
          <div></div>
        </div>
        <!--赛事介绍-->
        <div class="introstart">
          <h3 class="geekSizeTitle">2019“现未来”科技艺术之星奖</h3>
          <div class="geekDetails">
            <p>大赛旨在激励以科技为媒介进行创作的未来艺术之星，汇聚全球顶尖科技与艺术新锐人才，共同构建科技与艺术、教育与实践、创作与产业的跨界交流协作平台。</p>
            <br />
            <p>2019年“现未来”科技艺术之星奖自2019年4月正式上线启动，面向全球科技艺术创作者征集人工智能、交互、装置、投影、影像、游戏六大类别，共计收到来自全球科技艺术创作者投稿优秀作品290余件，其中参赛的国际创作者，涵盖国家包括：中国、澳大利亚、德国、哥伦比亚、法国、西班牙、美国、瑞士、哈萨克斯坦、英国、加拿大、日本、秘鲁、比利时、韩国、荷兰、新加坡。</p>
            <br />
            <p>本次大赛设立3大类奖项，共计8个获奖名额，其中包括：</p>
            <p>
              <strong>最佳创意奖1名</strong>
            </p>
            <p>奖金10000RMB（含税），奖杯以及证书</p>
            <p>
              <strong>单项奖6名</strong>
            </p>
            <p>奖金3000RMB（含税），奖杯以及证书，涵盖人工智能、交互、装置、投影艺术、影像、游戏6个类别</p>
            <p>
              <strong>新锐奖1名</strong>
            </p>
            <p>奖金3000RMB(含税），奖杯以及证书</p>
          </div>
        </div>

        <div class="eventIntroduction eventOverview prizeList">
          <h3 class="geekSizeTitle">最佳创意奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lh9r6z3N7Gwrc4qBV5EWJdqOfq_A"
              width="700"
              height="394"
              poster="https://image.manamana.net/1556493127846_c1.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4831"
                target="_blank"
              >《New Nature》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a
                  href="http://www.manamana.net/peopleCenter/9997"
                  target="_blank"
                >Marpi Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">影像类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/llbOgwg7sD3yHrMGXXom5uyza5Ke"
              width="700"
              height="394"
              poster="https://image.manamana.net/image/1535109093/mana_o_1cllq3lf11je8167jvcd1ssvu02c.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=2657"
                target="_blank"
              >《exodus》</a>
            </p>
            <p>
              <strong>
                获奖者：
                <a
                  href="http://www.manamana.net/peopleCenter/7276"
                  target="_blank"
                >ACCI BABA</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">装置类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/ll6Tgm_b_ICx4bbrCpDluOOEhwnC"
              width="700"
              height="394"
              poster="https://image.manamana.net/image/1521528194/mana_o_1c912bh6rff338oea5t610j55d.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=2308"
                target="_blank"
              >《dyebirth -Commentary movie-》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a href="http://www.manamana.net/peopleCenter/5744" target="_blank">nor</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">交互类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/ltB_5S0eKUqOqKcd-XE1YUgvYeXW"
              width="700"
              height="394"
              poster="https://image.manamana.net/1555043217595_微信图片_20180905161756.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4620"
                target="_blank"
              >《Instant 瞬息》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a
                  href="http://www.manamana.net/peopleCenter/133"
                  target="_blank"
                >Wonderlabs</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">游戏类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lmkyk2W09puDZ1Zz-0xh84Ek9dyS"
              width="700"
              height="394"
              poster="https://video.manamana.net/1555562699000Sequence 01_1.mp4?vframe/jpg/offset/255/w/992/h/563"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4675"
                target="_blank"
              >《Surrounding Worlds》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a
                  href="http://www.manamana.net/peopleCenter/14202"
                  target="_blank"
                >Atractor Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">投影类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lp2Fvk9e3ULaAihYpcubk6MB9usj"
              width="700"
              height="394"
              poster="https://image.manamana.net/1556521077234_1 .jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4847"
                target="_blank"
              >《新月 New Moon》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a
                  href="http://www.manamana.net/peopleCenter/14672"
                  target="_blank"
                >UpteamCMI</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">人工智能类单项奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lh9r6z3N7Gwrc4qBV5EWJdqOfq_A"
              width="700"
              height="394"
              poster="https://image.manamana.net/1556493127846_c1.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4831"
                target="_blank"
              >《New Nature》</a>
            </p>
            <p>
              <strong>
                获奖团队：
                <a
                  href="http://www.manamana.net/peopleCenter/9997"
                  target="_blank"
                >Marpi Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">新锐奖</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lg74whcAAOzxI-DYuBtPAPmExFWx"
              width="700"
              height="394"
              poster="https://image.manamana.net/1556260982880_1.png"
            ></video>
            <p>
              <a
                class="title"
                href="http://www.manamana.net/video/detail?id=4789"
                target="_blank"
              >《不要温和地踏入那个良夜 Do not go gentle into that good night》</a>
            </p>
            <p>
              <strong>
                获奖者：
                <a href="http://www.manamana.net/peopleCenter/8593" target="_blank">董彦泽</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="do-competition contantGeek" v-else>
      <div class="geekBoxs eventintros">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <!--<p>导航栏</p>-->
              <li>
                <router-link :to="{name: 'presentfuture', params: {matchId:matchId}}">
                  <a href>
                    Home
                    <img src="/static/geeknext.png" alt />
                  </a>
                </router-link>
              </li>
              <li class="geekMenuActive">
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">Awards</router-link>
              </li>
              <li>
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  Shortlisted
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:1003,page:1}}">
                  Exhibition
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:1003,page:2}}">
                  Events
                  <img src="/static/geeknext.png" />
                </router-link>
              </li>
            </ul>
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">Sign up</span>
          <a class="baroads unbaroads" v-show="matchObject.status == 1"></a>
          <div></div>
        </div>
        <!--赛事介绍-->
        <div class="introstart">
          <h3 class="geekSizeTitle">2019 “Present Future” Art & Technology Star Award</h3>
          <div class="geekDetails">
            <p>Encourage future stars to create an art combined with technology.Gather global creative talents from the disciplines such as technology and art.Establish a sophisticated platform for communication about art and technology, education and practice, creation and cross-border industries.</p>
            <br />
            <p>The 2019 “Present Future”Art & Technology Star Award is officially launched on April 2019, facing the world art creators collecting works of six categories: AI, Interaction, Installation, Projection Art, Film, and Game. Competition schedule once released registration, a total of from global excellent works of art and technology creators contribute more than 290 items.International creators of the competition, including China，Australia，Germany，Colombia，France，Spain，United States，Switzerland，Kazakhstan，United Kingdom，Canada，Japan，Belgium，Peru，South Korea，the Netherlands，Singapore.</p>
            <br />
            <p>There are 3 categories of awards in this competition, with a total of 8 awards, including ：</p>
            <p>
              <strong>The Best Creative Award</strong>
            </p>
            <p>10000RMB prize (Tax included) , trophy and certificate</p>
            <p>
              <strong>6 Individual Awards</strong>
            </p>
            <p>3000RMB prize (Tax included) , trophy and certificate. 6 categories of AI,Interaction, Installation, Projection Art, Film,Game</p>
            <p>
              <strong>1 Infinity Award</strong>
            </p>
            <p>3000RMB prize (Tax included) , trophy and certificate</p>
          </div>
        </div>

        <div class="eventIntroduction eventOverview prizeList">
          <h3 class="geekSizeTitle">Best Creative Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lh9r6z3N7Gwrc4qBV5EWJdqOfq_A"
              width="700"
              height="394"
              poster="http://image.manamana.net/1556493127846_c1.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4831"
                target="_blank"
              >《New Nature》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/9997"
                  target="_blank"
                >Marpi Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Film Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/llbOgwg7sD3yHrMGXXom5uyza5Ke"
              width="700"
              height="394"
              poster="http://image.manamana.net/image/1535109093/mana_o_1cllq3lf11je8167jvcd1ssvu02c.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=2657"
                target="_blank"
              >《exodus》</a>
            </p>
            <p>
              <strong>
                Winner：
                <a
                  href="http://en.manamana.net/peopleCenter/7276"
                  target="_blank"
                >ACCI BABA</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Installation Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/ll6Tgm_b_ICx4bbrCpDluOOEhwnC"
              width="700"
              height="394"
              poster="http://image.manamana.net/image/1521528194/mana_o_1c912bh6rff338oea5t610j55d.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=2308"
                target="_blank"
              >《dyebirth -Commentary movie-》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/5744"
                  target="_blank"
                >nor</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Interaction Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/ltB_5S0eKUqOqKcd-XE1YUgvYeXW"
              width="700"
              height="394"
              poster="http://image.manamana.net/1555043217595_微信图片_20180905161756.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4620"
                target="_blank"
              >《Instant 瞬息》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/133"
                  target="_blank"
                >Wonderlabs</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Game Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lmkyk2W09puDZ1Zz-0xh84Ek9dyS"
              width="700"
              height="394"
              poster="http://video.manamana.net/1555562699000Sequence 01_1.mp4?vframe/jpg/offset/255/w/992/h/563"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4675"
                target="_blank"
              >《Surrounding Worlds》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/14202"
                  target="_blank"
                >Atractor Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Projection Art Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lp2Fvk9e3ULaAihYpcubk6MB9usj"
              width="700"
              height="394"
              poster="http://image.manamana.net/1556521077234_1 .jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4847"
                target="_blank"
              >《新月 New Moon》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/14672"
                  target="_blank"
                >UpteamCMI</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">AI Star Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lh9r6z3N7Gwrc4qBV5EWJdqOfq_A"
              width="700"
              height="394"
              poster="http://image.manamana.net/1556493127846_c1.jpg"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4831"
                target="_blank"
              >《New Nature》</a>
            </p>
            <p>
              <strong>
                The Winning Team：
                <a
                  href="http://en.manamana.net/peopleCenter/9997"
                  target="_blank"
                >Marpi Studio</a>
              </strong>
            </p>
          </div>

          <h3 class="geekSizeTitle">Infinity Award</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <video
              ondragstart="return false"
              oncontextmenu="return false"
              onselectstart="return false"
              controls="true"
              controlslist="nodownload"
              src="http://video.manamana.net/HXex7qIIuqimoyrEgnodf7OJUdw=/lg74whcAAOzxI-DYuBtPAPmExFWx"
              width="700"
              height="394"
              poster="http://image.manamana.net/1556260982880_1.png"
            ></video>
            <p>
              <a
                class="title"
                href="http://en.manamana.net/video/detail?id=4789"
                target="_blank"
              >《不要温和地踏入那个良夜 Do not go gentle into that good night》</a>
            </p>
            <p>
              <strong>
                Winner：
                <a
                  href="http://en.manamana.net/peopleCenter/8593"
                  target="_blank"
                >董彦泽 Yanze Dong</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.2019“现未来”科技艺术之星奖-获奖公示") + " | MANA"
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      matchId: -1,
      matchObject: {}
    };
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  created() {
    this.matchId =
      this.$route.params.matchId == null || this.$route.params.matchId == ""
        ? 1003
        : this.$route.params.matchId;
    // if (this.matchId != -1) {
    //   this.$http
    //     .get("/api/match/getMatch", { params: { matchId: this.matchId } })
    //     .then(response => {
    //       this.matchObject = response.data;
    //     });
    // }
  },
  methods: {
    signGoTo() {
      if (this.$store.state.peopleMessage == "") {
        this.$router.push("/login");
        return;
      }
      debugger;
      let $this = this;
      this.$http
        .post(
          "/api/match/user/checkIsMatch?userId=" +
            this.$store.state.peopleMessage.userId +
            "&matchId=" +
            this.matchId
        )
        .then(response => {
          debugger;
          if (response.code == 400) {
            $this.$router.push({ path: "/signupZ?matchId=" + this.matchId });
          } else {
            this.$router.push({ path: "/UpVideo?matchId=" + this.matchId });
          }
        });
    }
  }
};
</script>
<style>
.prizeList .geekDetails {
  margin-top: 20px;
}
.prizeList .geekDetails .title {
  display: block;
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}
.prizeList .geekSizeTitle {
  padding-top: 140px;
}
.prizeList .geekDetails a {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/match/prizePz.vue